// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select[disabled][data-v-0b8923be], .select.is-disabled[data-v-0b8923be] {\n  box-shadow: none;\n}\n.select[disabled] + .icon[data-v-0b8923be], .select.is-disabled + .icon[data-v-0b8923be] {\n  color: var(--magic-dropdown-disabled-darker, #2e2e2e);\n}\n.select--link[data-v-0b8923be]:focus {\n  box-shadow: inset 0 0 0 1px #f8c51b;\n}\n.select:focus .option[data-v-0b8923be] {\n  background: #1f2223;\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
